module.exports = __webpack_public_path__ + "img/undraw_secure_files_re_6vdh.8e7168ca.svg";